@if (!submitted() && data() && sortedInputs().length) {
  <div class="tw-w-full">
    @if (imageInputs().length) {
      <div class="tw-flex tw-flex-col tw-gap-3 tw-pl-2 tw-pr-3">
        @for (each of imageInputs(); track each.originalIndex) {
          <div [id]="'imgInp' + each.originalIndex"
               class="tw-w-full tw-max-w-[268px] tw-bg-white tw-rounded-2 tw-flex tw-items-center tw-gap-3 tw-shadow-z1"
               [class.tw-p-2]="centraliseImage()"
               [class.tw-pt-1]="!centraliseImage()"
               [class.tw-px-3]="!centraliseImage()"
               rippleEffect="rippleEffect"
               rippleClass="ripple-blue"
               (click)="selectedIndex.set(each.originalIndex)"
               (callback)="sendMessage()">
            <img [src]="each.params.imageUrl" alt="User" class="tw-w-[50px]" />
            <div class="tw-font-body tw-font-medium tw-text-300 tw-leading-5">{{ each.text }}</div>
          </div>
        }
      </div>
    }
    @for (each of buttonInputs(); track each.originalIndex) {
      <span
        type="button"
        [id]="'buttonInput' + each.originalIndex"
        data-testid="chat-option"
        class="tw-w-full tw-flex tw-justify-center tw-items-center tw-border-t tw-border-teal-300 tw-py-2 tw-text-center tw-font-semibold tw-font-lexend tw-text-teal-600"
        [class.tw-pointer-events-none]="isEffectivelyClosed()"
        (click)="selectedIndex.set(each.originalIndex); sendMessage()">
        {{ each.text }}
      </span>
    }
  </div>
}
